<template>
  <section>
    <dialog-component
      :dialogData="dialogData"
      :isShow="isShow"
      :isPlain="true"
      :hasButton="false"
      :width="500"
      :show-close="true"
      @cancel="handleCancle"
    >
      <div
        class="tip-text"
        v-html="content">
      </div>
    </dialog-component>
  </section>
</template>

<script>
import { getLogEmailDetail} from '@api/account'

export default {
  name: 'logEmailPopup',
  props:{
    value:{
      type:Boolean,
      default:false
    },
    smsLogId:{
      type:Number,
      default:0
    }
  },
  data(){
    return{
      isShow:false,
      content:''
    }
  },
  computed:{
    dialogData(){
      return{
        title:'Email'
      }
    }
  },
  watch:{
    value:{
      immediate:true,
      handler(val){
        this.isShow = val
      }
    },
    smsLogId:{
      immediate:true,
      handler(val){
        if(val){
          console.log('val---',val)
          this.$nextTick(()=>{
            this.network().getLogEmailDetail()
          })
        }
      }
    },

  },
  methods:{
    handleCancle(){
      this.$emit('input',false)
    },
    network(){
      return{

        getLogEmailDetail: async () => {
          console.log('this.smsLogId---',this.smsLogId)
          const { data } = await getLogEmailDetail({
            sms_log_id: this.smsLogId,
          })
          this.content = data.content
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
